import { type DocumentTableRow } from 'features/knowledgeDocumentViewer'
import {
  getCantileverDocumentId,
  getSystemDocumentBqId,
  type SystemDocumentEntry,
} from 'features/knowledgeDocumentViewer/types/systemDocumentEntries'

const SUMMARY_KEYWORDS_SEPARATOR = '@@@'

export function parseRichTextSummary(raw: string | undefined): {
  summary: string | null
  keywords: string[]
} {
  if (!raw) return { summary: null, keywords: [] }

  const [summaryPart, keywordsPart] = raw.split(SUMMARY_KEYWORDS_SEPARATOR)
  const summary = summaryPart?.trim() || null
  const keywords = keywordsPart
    ? keywordsPart
        .split(',')
        .map((k) => k.trim())
        .filter(Boolean)
    : []

  return { summary, keywords }
}

export function transformSystemDocumentToTableRow(
  entry: SystemDocumentEntry
): DocumentTableRow {
  const data = entry.entry.data
  const { summary, keywords } = parseRichTextSummary(data.rich_text_summary)

  return {
    id: entry.entry.id,
    title: data.title,
    filename: data.filename,
    documentTitle: data.document_title ?? data.title ?? null,
    system: data.system ?? null,
    vendor: data.vendor_name ?? null,
    docType: data.document_type ?? null,
    drawing: data.drawing_number ?? null,
    timestamp: data.uploadDate ?? null,
    numPages: data.total_pages ?? null,
    revisionCode: data.revision_code ?? null,
    revisionDate: data.revision_date ?? null,
    summary,
    keywords,
    bqDocumentId: getSystemDocumentBqId(entry),
    cantileverDocumentId: getCantileverDocumentId(entry),
  }
}
